import moment from "moment";

import { Notice } from "@/DesignSystem/Molecules/Notice";
import { MedicalItemScreeningTest } from "@/Patient/Models/MedicalSummary/MedicalItemScreeningTest";
import { MedicalRequestFormRowComponent } from "./MedicalRequestFormRow";

import styles from "./MedicalRequestPopupController.module.scss";

function ScreeningTestViewComponent(props: { screeningTest: MedicalItemScreeningTest }): JSX.Element {
    if (!props.screeningTest)
        return null;

    return (
        <div id="ScreeningTestViewComponent">
            <MedicalRequestFormRowComponent label="FrequencyLabel" dataCy="frequencyRow">
                {props.screeningTest.getFrequency()?.getName()}
            </MedicalRequestFormRowComponent>

            <MedicalRequestFormRowComponent label="ReminderLabel" dataCy="reminderRow">
                {props.screeningTest.getReminder()?.getName()}
            </MedicalRequestFormRowComponent>

            <MedicalRequestFormRowComponent label="StartAgeLabel" dataCy="startAgeRow">
                {props.screeningTest.model.StartAge?.toString()}
            </MedicalRequestFormRowComponent>

            <MedicalRequestFormRowComponent label="EndAgeLabel" dataCy="endAgeRow">
                {props.screeningTest.model.EndAge?.toString()}
            </MedicalRequestFormRowComponent>

            <MedicalRequestFormRowComponent label="StatusLabel" dataCy="statusRow" shouldHide={!props.screeningTest.model.StatusLookupId}>
                <p>{props.screeningTest.getStatusLocalizedValue()}</p>
                {props.screeningTest.canShowStatusReminderText() &&
                    cacheStore.ClinicSettings.EnablePreventiveActivityEnhancements
                    ? (
                        <div className={styles.notice}>
                            <Notice type={props.screeningTest.isInToDoPeriod() ? "warning" : "info"} message={props.screeningTest.getStatusReminderText()} />
                        </div>
                    )
                    : <p style={{ fontStyle: "italic" }}>{props.screeningTest.getStatusReminderText()}</p>
                }
            </MedicalRequestFormRowComponent>

            <MedicalRequestFormRowComponent label="CompletionDateLabel" dataCy="completionDateRow" shouldHide={!props.screeningTest.isStatusCompleted()}>
                {props.screeningTest.model.CompletionDate && moment(props.screeningTest.model.CompletionDate).format("YYYY-MM-DD")}
            </MedicalRequestFormRowComponent>

            <MedicalRequestFormRowComponent label="InterpretationLabel" dataCy="interpretationRow" shouldHide={!props.screeningTest.isStatusCompleted()}>
                {props.screeningTest.getInterpretationLocalizedValue()}
            </MedicalRequestFormRowComponent>

            <MedicalRequestFormRowComponent label="CareElementDueDateLabel" dataCy="dueDateRow">
                {props.screeningTest.model.DueDate && moment(props.screeningTest.model.DueDate).format("YYYY-MM-DD")}
            </MedicalRequestFormRowComponent>

            <MedicalRequestFormRowComponent label="NotesLabel" dataCy="notesRow" className={styles.notesRow}>
                {props.screeningTest.model.Notes}
            </MedicalRequestFormRowComponent>
        </div>
    );
}

export { ScreeningTestViewComponent };
